import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UtilService } from '@service/util/util.service';
import { AccountSettingsService } from '@service/accountSettings/account-settings.service';
import { Cargochief } from '@service/cargochief/cargochief.service';
import { CARGOCHIEF_KEYS } from '@domain/constants/app-variables';
import { IS_NOT_EMPTY, IS_NOT_NULL_OR_UNDEFINED } from 'cargo-chief-commons';
import {
	CapacitySearchSettings,
	DefaultCapacitySearchSettings,
} from '@domain/interface/capacity-search-settings';
import {
	CAPACITY_SEARCH_SETTINGS,
	getCapacitySearchTabs,
} from '@domain/constants/capacity-search-settings';

@Component({
	selector: 'app-capacity-search-settings',
	templateUrl: './capacity-search-settings.component.html',
	styleUrls: ['./capacity-search-settings.component.scss'],
})
export class CapacitySearchSettingsComponent implements OnInit {
	@Output() onCapacitySearchSettingsChange: EventEmitter<any> = new EventEmitter();
	@Input() defaultSettings: DefaultCapacitySearchSettings = {
		minimumFrequency: 0,
		minimumTruckCount: 0,
		defaultTrailerTypes: [],
		defaultPickupDateType: CAPACITY_SEARCH_SETTINGS.pickupDate,
		defaultCapacitySearchTab: getCapacitySearchTabs(this.accountSettings.CARRIER_QUALITY).Notes
			.label,
		pickupDateTypes: [],
		searchableTrailerTypes: [],
		searchTruckOriginDeadheadLimit: null,
		searchTruckDestinationDeadheadLimit: null,
		capacitySearchTabs: CAPACITY_SEARCH_SETTINGS.capacitySearchTabsListItems,
	};

	SLIDER_RANGE: any = {
		min: 5,
		max: 500,
	};
	accountId = null;
	account = null;
	SLIDER_STEP_SIZE = 5;

	CARGOCHIEF_KEYS = CARGOCHIEF_KEYS;

	constructor(
		private cargochief: Cargochief,
		public utilService: UtilService,
		public accountSettings: AccountSettingsService
	) {}

	ngOnInit(): void {
		this.accountId = this.cargochief.ACCOUNT_ID;
		this.initializeCapacitySearchSettings();
	}

	initializeCapacitySearchSettings() {
		this.fireEventToUpdateParrent();
	}

	sliderChanged(key, value) {
		if (key === 'ORIGIN_DEADHEAD_SLIDER') {
			this.defaultSettings.searchTruckOriginDeadheadLimit = value;
		} else {
			this.defaultSettings.searchTruckDestinationDeadheadLimit = value;
		}
		this.fireEventToUpdateParrent();
	}

	sliderButtonClicked(key: string, ngModel: string, stepChanged) {
		if (
			this.defaultSettings[ngModel] + stepChanged >= this.SLIDER_RANGE.min &&
			this.defaultSettings[ngModel] + stepChanged <= this.SLIDER_RANGE.max
		) {
			this.defaultSettings[ngModel] += stepChanged;
			this.sliderChanged(key, this.defaultSettings[ngModel]);
		}
		this.fireEventToUpdateParrent();
	}

	handleMinimumFrequencyChange(event: any) {
		if (
			IS_NOT_EMPTY(event.target.value) &&
			IS_NOT_NULL_OR_UNDEFINED(event.target.value) &&
			event.target.value >= 0
		) {
			this.defaultSettings.minimumFrequency = event.target.value;
		} else {
			this.defaultSettings.minimumFrequency = 0;
		}
		this.fireEventToUpdateParrent();
	}

	handleMinimumTruckCountChange(event: any) {
		if (
			IS_NOT_EMPTY(event.target.value) &&
			IS_NOT_NULL_OR_UNDEFINED(event.target.value) &&
			event.target.value >= 0
		) {
			this.defaultSettings.minimumTruckCount = event.target.value;
		} else {
			this.defaultSettings.minimumTruckCount = 0;
		}
		this.fireEventToUpdateParrent();
	}

	handleTrailerTypesChange(event: any) {
		this.defaultSettings.defaultTrailerTypes = event.value;
		this.fireEventToUpdateParrent();
	}

	handleDefaultPickupDateTypeChange(event: any) {
		this.defaultSettings.defaultPickupDateType = event.value;
		this.fireEventToUpdateParrent();
	}

	handleDefaultCapacitySearchTabChange(event: any) {
		this.defaultSettings.defaultCapacitySearchTab = event.value;
		this.fireEventToUpdateParrent();
	}

	fireEventToUpdateParrent() {
		const capacitySearchSettings: CapacitySearchSettings = {
			pickupDateType: this.defaultSettings.defaultPickupDateType,
			originDeadHead: this.defaultSettings.searchTruckOriginDeadheadLimit,
			destinationDeadHead: this.defaultSettings.searchTruckDestinationDeadheadLimit,
			defaultMinimumTruckCount: this.defaultSettings.minimumTruckCount,
			defaultMinimumFrequency: this.defaultSettings.minimumFrequency,
			defaultCapacitySearchTab: this.defaultSettings.defaultCapacitySearchTab,
			defaultTrailerTypes: this.defaultSettings.defaultTrailerTypes.join(),
			override: false,
		};
		this.onCapacitySearchSettingsChange.emit(capacitySearchSettings);
	}
}
